import ContentLayout from "@/modules/merchant/layout/contentLayout";
import PeopleIcon from "@mui/icons-material/People";
import Content from "./content";

const UserDetail = () => {
  return (
    <ContentLayout icon={<PeopleIcon />} title="خدمات مشتریان" isContainerFluid>
      <Content />
    </ContentLayout>
  );
};

export default UserDetail;
